import React from "react";
import StatusInfo from "../../../../StatusInfo/StatusInfo";
import Card from "../../../../UI/Card";
import classes from './AssessmentLessonCard.module.css'

const AssessmentLessonCard = ({ backgroundImage, statuses, description, handleClick }) => {

    return (
        <>
            <div className={classes.CardContainer} >
                <button className={classes.CardLink} onClick={handleClick}>
                    <Card backgroundImage={backgroundImage} dropClass={classes.AssessmentLessonCard}>
                        {statuses.map((status, index) =>
                            <StatusInfo key={index} index={index} status={status.status} dropClass={classes.StatusCard} submittedDate={status.submittedDate} assessmentDueDate={status.assessmentDueDate} questionNum={status.questionNum} questionComplated={status.questionComplated} />
                        )}
                    </Card>
                </button>
                {description && <p className={classes.Description} title={description}>{description}</p>}
            </div>

        </>
    )
}

export default AssessmentLessonCard;